import { useLayoutEffect, useState } from "react";
import { required, TextInput } from "react-admin";
import { useFormContext } from "react-hook-form";
import { differenceInYears, parseISO, isValid } from "date-fns";
import React from "react";

export const ComputedAgeInputWatch = (meta) => {
  const { source_name, index, is_required } = meta;

  const { setValue, getValues, register, watch } = useFormContext();
  const [computedAge, setComputedAge] = useState("");

  // Watch changes in both date columns
  const date1 = watch("driver_dob_gregorian");
  const date2 = watch("accident_time");

  const parseDate = (dateValue) => {
    if (!dateValue) return null;
    if (dateValue instanceof Date) return dateValue; // Already a Date object
    if (typeof dateValue === "string") {
      const parsed = parseISO(dateValue);
      return isValid(parsed) ? parsed : null; // Ensure valid date
    }
    return null;
  };

  useLayoutEffect(() => {
    const parsedDate1 = parseDate(date1);
    const parsedDate2 = parseDate(date2);

    if (parsedDate1 && parsedDate2) {
      const age = differenceInYears(parsedDate2, parsedDate1);
      const ageString = age.toString();

      setComputedAge(ageString);
      setValue(source_name, ageString); // Store computed age as a string
    }
  }, [date1, date2, source_name, setValue]);

  let disabled = true;

  return (
    <>
      {/* Computed Age Input (disabled) */}
      <TextInput
        fullWidth
        validate={is_required ? [required()] : undefined}
        source={source_name}
        key={index}
        readOnly={disabled}
      />

      {/* Hidden input to ensure the computed value is submitted when disabled */}
    </>
  );
};


export const HiddenColumn = (meta) => {
    const { source_name, index, is_required } = meta;
  
    const { setValue, getValues, register, watch } = useFormContext();
  
  

  
   
  
    return (
 
  
        <input type="hidden" {...register(source_name)} />
    );
  };
  
